export default __webpack_public_path__ + "static/media/cold-brew.e84b12bf.jpg";